import { render, staticRenderFns } from "./date-range.vue?vue&type=template&id=b8632f50&"
import script from "./date-range.vue?vue&type=script&lang=js&"
export * from "./date-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports